import type Point from '@arcgis/core/geometry/Point';
import { GEOMETRY_TYPES } from '../constants';
import type { Geometry } from '../types';

export const getGeometryCenter = (geometry: Geometry): Point | null => {
  if (geometry.type === GEOMETRY_TYPES.POINT) {
    return geometry as Point;
  }
  if (geometry.extent) {
    return geometry.extent.center as Point;
  }
  if (geometry.centroid) {
    return geometry.centroid as Point;
  }
  if (geometry.rings && geometry.rings.length > 0) {
    const ring = geometry.rings[0];
    const sumX = ring.reduce((sum, point) => sum + point[0], 0);
    const sumY = ring.reduce((sum, point) => sum + point[1], 0);
    return {
      x: sumX / ring.length,
      y: sumY / ring.length,
      spatialReference: geometry.spatialReference,
    } as Point;
  }
  if (geometry.paths && geometry.paths.length > 0) {
    const path = geometry.paths[0];
    const sumX = path.reduce((sum, point) => sum + point[0], 0);
    const sumY = path.reduce((sum, point) => sum + point[1], 0);
    return {
      x: sumX / path.length,
      y: sumY / path.length,
      spatialReference: geometry.spatialReference,
    } as Point;
  }
  return null;
};
